module.exports = __webpack_public_path__ + "static/media/twitter.df4d67f8.png";